import { type ReactNode } from 'react'
import { Card } from '../ui/Card'

interface ConsentCardProps {
  children: ReactNode
}

export function ConsentCard({ children }: ConsentCardProps) {
  return (
    <Card className="w-full max-w-md">
      {children}
    </Card>
  )
}
